import { css } from '@emotion/react';

const style = (fontFamily) => css`
  pre {
    font-family: ${fontFamily || "'Nunito', sans-serif"};
  }

  code,
  kbd,
  samp {
    font-family: ${fontFamily || "'Nunito', sans-serif"};
  }

  body {
    font-family: ${fontFamily || "'Nunito', sans-serif"};
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-family: ${fontFamily || "'Nunito', sans-serif"};
  }
  p,
  a {
    font-family: ${fontFamily || "'Nunito', sans-serif"};
  }

  code {
    font-family: ${fontFamily || "'Nunito', sans-serif"};
  }
`;

export default style;
